<template>
	<div>
		<v-combobox
			v-if="return_object"
			:rules="rules"
			:readonly="readonly"
			:multiple="multiple"
			:value="value"
			:hint="hint"
			:hide-details="hide_details"
			:loading="loading"
			:items="items"
			:class="{ dense_input: dense }"
			:solo="solo"
			item-text="email"
			item-value="id"
			hide-selected
			append-icon=""
			no-filter
			dense
			small-chips
			deletable-chips
			:auto-select-first="true"
			:search-input.sync="search"
			@paste.native="onPaste($event)"
			@change="onChange($event)">
			<template v-slot:label>
				{{ param | maestroParamLabel }}
			</template>
		</v-combobox>
		<v-combobox
			v-else
			:rules="rules"
			:readonly="readonly"
			:multiple="multiple"
			:value="value"
			:hint="hint"
			:hide-details="hide_details"
			:loading="loading"
			:items="items"
			:class="{ dense_input: dense }"
			:solo="solo"
			hide-selected
			append-icon=""
			no-filter
			dense
			small-chips
			deletable-chips
			:auto-select-first="true"
			:search-input.sync="search"
			@paste.native="onPaste($event)"
			@change="onChange($event)">
			<template v-slot:label>
				{{ param | maestroParamLabel }}
			</template>
		</v-combobox>
	</div>
</template>

<script>
import { debounce } from 'debounce'
export default {
	props: [
		'value',
		'rules',
		'param',
		'hint',
		'readonly',
		'multiple',
		'solo',
		'dense',
		'hide_details',
		'return_object'
	],
	data () {
		return {
			loading: false,
			items: [],
			search: '',
			pasting: false
		}
	},
	watch: {
		search (val) {
			if (val) {
				this.onType(val)
			} else {
				this.items = []
			}
		}
	},
	methods: {
		onChange (value) {
			this.$emit('change', value)
			this.items = []
			this.search = ''
		},
		onPaste (evt) {
			this.pasting = true
			setTimeout(() => {
				this.pasting = false
			}, 300)
		},
		onType: debounce(function (val) {
			this.$nextTick(() => {
				if (!val) return
				if (val.length < 3) return
				if (this.loading) return
				if (this.pasting) {
					if (/.+@.+/.test(val) ||
						val.indexOf(',') > -1 ||
						val.indexOf(';') > -1) {
						let testValue = val.replace(/ /g, '')
						testValue = testValue.split(/,|;/)
						if (Array.isArray(this.value)) {
							this.$emit('change', [...this.value, ...testValue])
						} else {
							if (this.multiple) {
								this.$emit('change', testValue)
							} else {
								this.$emit('change', testValue[0])
							}
						}
						this.items = []
						this.search = ''
						return
					}
				}
				this.loading = true
				this.$EsMaestro.contact_search(val)
					.then(contacts => {
						if (this.return_object) {
							this.items = contacts
						} else {
							this.items = contacts.map(contact => contact.email)
						}
					})
					.catch(err => {
						console.error(err)
					})
					.finally(() => (this.loading = false))
			})
		}, 100)
	}
}
</script>

<style lang="stylus" scoped>
.v-input
	>>>.v-chip
		background-color: var(--v-background-darken1) !important
</style>



// WEBPACK FOOTER //
// src/components/field_email.vue